import { Card, Col, Row, Checkbox, CheckboxProps, Spin } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { FiTruck } from "react-icons/fi";
import { MdOutlineInventory } from "react-icons/md";
import { AiOutlineFlag } from "react-icons/ai";
import { BsFileEarmarkMedical } from "react-icons/bs";
import { BiBarChartAlt } from "react-icons/bi";
import { Link } from "react-router-dom";
import { componentPalette } from "src/theme/component-palette";
import Tank from "../../assets/tank.jpeg";
import Fugitive from "../../assets/fugitive.jpeg";
import TerminalAndMarketing from "../../assets/terminal-and-marketing.jpeg";
import Combustion from "../../assets/combustion.jpeg";
import Flare from "../../assets/flare.png";
import WasteWater from "../../assets/waste-water.jpeg";
import Others from "../../assets/others.jpg";
import "./VocsInventory.css";
import { useEffect, useMemo, useState } from "react";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { utilsStore } from "src/stores/utils-store";
import { useShallow } from "zustand/react/shallow";
import { useDidMount } from "src/hook/useDidMount";
import { profileStore } from "src/stores/profile-store";
import { list_include_others_inventory } from "src/entity/common/common.constant";
import { myTasksStore } from "src/stores/my-tasks-store";

const items = [
  {
    key: "voc-inven-menu-1",
    icon: <MdOutlineInventory />,
    label: "Fugitive",
    link: "/vocs-inventory/fugitive/information-voc-result",
    imgPath: Fugitive,
    activeMenu: ["/vocs-inventory"],
  },
  {
    key: "voc-inven-menu-3",
    icon: <FiTruck />,
    label: "Combustion",
    link: "/vocs-inventory/combustion/setup-stack-information",
    imgPath: Combustion,
    activeMenu: ["/vocs-inventory", "/vocs-inventory/combustion"],
  },
  {
    key: "voc-inven-menu-5",
    icon: <BsFileEarmarkMedical />,
    label: "Flare",
    link: "/vocs-inventory/flare/setup-heating-value",
    imgPath: Flare,
    activeMenu: ["/vocs-inventory", "/vocs-inventory/flare"],
  },
  {
    key: "voc-inven-menu-2",
    icon: <MdOutlineInventory />,
    label: "Transportation & Marketing",
    link: "/vocs-inventory/transportation-and-marketing/setup-loading-information",
    imgPath: TerminalAndMarketing,
    activeMenu: ["/vocs-inventory", "/vocs-inventory/transportation-and-marketing"],
  },
  {
    key: "voc-inven-menu-4",
    icon: <AiOutlineFlag />,
    label: "Tank",
    link: "/vocs-inventory/tank/setup-tank-information",
    imgPath: Tank,
    activeMenu: ["/vocs-inventory", "/vocs-inventory/tank"],
  },

  {
    key: "voc-inven-menu-6",
    icon: <BiBarChartAlt />,
    label: "Wastewater Treatment",
    link: "/vocs-inventory/waste-water-treatment/setup-information",
    imgPath: WasteWater,
    activeMenu: ["/vocs-inventory", "/vocs-inventory/waste-water-treatment"],
  },
  {
    key: "voc-inven-menu-7",
    icon: <BiBarChartAlt />,
    label: "Others",
    link: "/vocs-inventory/others/information",
    imgPath: Others,
    activeMenu: ["/vocs-inventory", "/vocs-inventory/others"],
  },
];

const VocsInventory = () => {
  const [focus, setFocus] = useState<Record<string, boolean>>({
    "voc-inven-menu-1": false,
    "voc-inven-menu-2": false,
    "voc-inven-menu-3": false,
    "voc-inven-menu-4": false,
    "voc-inven-menu-5": false,
    "voc-inven-menu-6": false,
    "voc-inven-menu-7": false,
  });

  const profile = profileStore(useShallow((state) => state.profile));
  const getFocusCompany = utilsStore(useShallow((state) => state.getFocusCompany));
  const dataFocus = utilsStore(useShallow((state) => state.data));
  const loading = utilsStore(useShallow((state) => state.loading));
  const upsert = utilsStore(useShallow((state) => state.upsertFocusCompany));

  const setCurrentActiveMenus = utilsStore(useShallow((state) => state.setCurrentActiveMenus));
  const getMyTasks = myTasksStore(useShallow((state) => state.getMyTasks));

  // console.log("data Focus : ", dataFocus);
  // console.log("FOCUS : ", focus);
  useDidMount(() => {
    if (profile?.activeCompany?._id) getFocusCompany(profile.activeCompany._id);
  });

  useEffect(() => {
    // console.log("TRIGGER COMPANY CHANGE : ", profile?.activeCompany);
    if (profile?.activeCompany) {
      setFocus({
        "voc-inven-menu-1": false,
        "voc-inven-menu-2": false,
        "voc-inven-menu-3": false,
        "voc-inven-menu-4": false,
        "voc-inven-menu-5": false,
        "voc-inven-menu-6": false,
        "voc-inven-menu-7": false,
      });
      getFocusCompany(profile.activeCompany._id);
    }
  }, [profile?.activeCompany]);

  useEffect(() => {
    if (dataFocus?.length) {
      const mappingFocus: Record<string, boolean> = {};
      dataFocus.forEach((item) => {
        mappingFocus[item.menu] = item.isFocus;
      });
      setFocus((prevState) => ({ ...prevState, ...mappingFocus }));
    }
  }, [dataFocus]);

  const onChange = async (e: CheckboxChangeEvent, key: string) => {
    setFocus((prevState) => ({ ...prevState, [key]: e.target.checked }));
    const find = dataFocus.find((item) => item.menu == key);
    if (find)
      await upsert({
        _id: find._id,
        menu: key,
        companyId: profile?.activeCompany._id as string,
        isFocus: e.target.checked,
      });
    else
      await upsert({
        menu: key,
        companyId: profile?.activeCompany._id as string,
        isFocus: e.target.checked,
      });
    getMyTasks();
  };

  const setupActiveMenu = (active: string[], isFocusing: boolean) => {
    if (isFocusing) setCurrentActiveMenus(active);
  };

  const filtersInventoryItems = useMemo(() => {
    if (profile?.activeCompany && list_include_others_inventory.includes(profile.activeCompany.companyName.toUpperCase())) {
      return items;
    } else {
      return items.filter((inventory) => inventory.key != "voc-inven-menu-7");
    }
  }, [profile?.activeCompany]);

  return (
    <div className="w-full p-10">
      <Row
        justify={"space-evenly"}
        gutter={[
          { xs: 12, sm: 24, md: 48 },
          { xs: 12, sm: 24, md: 48 },
        ]}
      >
        {loading ? (
          <Spin spinning />
        ) : (
          <>
            {filtersInventoryItems.map((item, index) => (
              <Col xs={24} sm={12} md={8} key={index} className="flex flex-row justify-center">
                <Card
                  id={"custom-card-menu"}
                  styles={{
                    body: { padding: 0, overflow: "hidden" },
                  }}
                  title={
                    <Checkbox className="w-full" onChange={(val) => onChange(val, item.key)} checked={focus[item.key]}>
                      <div className="w-full text-center">
                        <span
                          style={{
                            color: "#ffffff",
                            fontSize: item?.label.length > 23 ? "18px" : "20px",
                            fontWeight: "600",
                            width: "100%",
                            textAlign: "center",
                          }}
                        >
                          {item?.label}
                        </span>
                      </div>
                    </Checkbox>
                  }
                  style={{ background: componentPalette.primary, maxHeight: "20rem", width: "19.5rem" }}
                >
                  <Link to={focus[item.key] ? item.link : ""} onClick={() => setupActiveMenu(item.activeMenu, focus[item.key])}>
                    <img src={item.imgPath} alt={""} style={{ height: 180, width: "100%" }} />
                  </Link>
                </Card>
              </Col>
            ))}
          </>
        )}
      </Row>
    </div>
  );
};

export default VocsInventory;
